import { render } from "./AccoglienzaSostitutiOspiti.vue?vue&type=template&id=11f8933d"
import script from "./AccoglienzaSostitutiOspiti.vue?vue&type=script&lang=js"
export * from "./AccoglienzaSostitutiOspiti.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__